import { render, staticRenderFns } from "./uoload.vue?vue&type=template&id=792e49c0&scoped=true&"
import script from "./uoload.vue?vue&type=script&lang=js&"
export * from "./uoload.vue?vue&type=script&lang=js&"
import style0 from "./uoload.vue?vue&type=style&index=0&id=792e49c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792e49c0",
  null
  
)

export default component.exports